import type { UiTheme } from "@/types"

export const THEME_STORAGE_KEY = "vm:uiTheme"

const VALID: ReadonlySet<UiTheme> = new Set(["dark", "light", "system"])

export function loadPersistedTheme(): UiTheme {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY)
    if (raw && VALID.has(raw as UiTheme)) return raw as UiTheme
  } catch {
    /* noop */
  }
  return "system"
}
